import { render, staticRenderFns } from "./ObservacoesGeraisVisitaCard.vue?vue&type=template&id=e2d714b8&"
import script from "./ObservacoesGeraisVisitaCard.vue?vue&type=script&lang=js&"
export * from "./ObservacoesGeraisVisitaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports